module.exports = __webpack_public_path__ + "static/media/3pl4.b326ab26.png";